import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto max-w-content px-4 md:px-8 py-24 md:py-32 text-center">
      <h1 className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">
        404
      </h1>
      <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-900">
        页面走丢了
      </h2>
      <p className="mt-3 text-sm text-foreground-500">
        你访问的地址 <span className="text-primary-600">{location.pathname}</span> 不存在或已被移除。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line" />
          去搜索
        </Link>
      </div>
    </div>
  );
}